import { AuthModal, View } from '@fairygodboss/ui';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

import { UseModalState } from '../../context/ModalContext';
import { EmitMetric } from '../../utils/Analytics/VisibilityPixel/VisibilityPixel';

const LOGIN_PAGE_COOKIE = 'LOGIN-PLACEMENT';

export const ModalTrigger = ({ ...props }) => {
    const {
        modalOpen,
        setModalOpen,
        auth0,
        timer,
        loginMetrics,
        leadInLogin,
        leadInPopup,
        setLayoutType,
        isPayWall,
        regWall,
        layoutType,
        callToActionSubTitle,
    } = UseModalState();
    const [loginPath, setLoginPath] = useState('');
    const [mounted, setMounted] = useState(false);
    const closeModal = () => {
        setModalOpen(null);
        setLayoutType(String('none'));
        if (isPayWall) {
            EmitMetric({
                ...loginMetrics,
                misc_event_type: 'signup-wall-closed',
                misc_event_count: 1,
            });
        }
    };
    useEffect(() => {
        setLoginPath(window.location.pathname);
        setMounted(true);
    }, []);

    useEffect(() => {
        if (modalOpen) {
            Cookies.set(LOGIN_PAGE_COOKIE, window.location.pathname, {
                expires: 2095,
            });
        }
    }, [modalOpen]);
    return (
        <View>
            <style jsx global>
                {`
                    body {
                        overflow: ${modalOpen ? 'hidden' : 'auto'};
                    }
                    .modalContainer {
                        display: ${modalOpen ? 'block!important' : 'none'};
                    }
                    .component-Login-LoginLayoutComponent.wide {
                        width: 95% !important;
                        padding: 20px 10px !important;
                    }
                    .content {
                        min-height: 616px;
                    }
                    @media (max-width: 768px) {
                        .content.wide .closeButton svg path {
                            fill: rgb(53, 53, 53) !important;
                        }
                    }

                    @media (max-width: 905px) and (orientation: portrait) {
                        dialog {
                            width: 530px !important;
                        }
                        .modal {
                            height: 595px !important;
                        }
                        .content {
                            width: 530px !important;
                            overflow-y: hidden !important;
                            background-color: transparent !important;
                        }
                        .component-Login-LoginLayoutComponent {
                            width: 95% !important;
                            padding: 20px 10px !important;
                        }
                        .closeButton {
                            margin-top: 15px;
                            margin-right: 10px;
                        }
                    }
                    @media (max-width: 905px) and (orientation: landscape) {
                        .content {
                            width: 340px !important;
                            background-color: transparent !important;
                        }
                        .closeButton {
                            margin-top: 5px;
                            margin-right: 0px;
                        }

                        .component-Login-LoginLayoutComponent {
                            width: 95% !important;
                            padding: 20px 10px !important;
                        }
                    }
                    @media (min-width: 905px) and (orientation: landscape) {
                        .component-Login-LoginLayoutComponent.wide {
                            width: 95% !important;
                            padding: 20px 10px !important;
                        }
                    }

                    @media (max-width: 575px) and (orientation: portrait) {
                        dialog {
                            width: 100% !important;
                        }
                        .modal {
                            min-height: 595px;
                        }
                        .content {
                            width: 100% !important;
                        }
                    }

                    @media (max-height: 611px) {
                        .modal {
                            height: 100% !important;
                            overflow: scroll !important;
                        }
                    }
                `}
            </style>
            {mounted && modalOpen && (
                <AuthModal
                    className="modalContainer"
                    isOpen={modalOpen}
                    timer={timer}
                    onClose={closeModal}
                    auth0={auth0}
                    loginRedirectPath={loginPath}
                    loginMetrics={loginMetrics}
                    callToActionSubTitle={callToActionSubTitle}
                    displayMode="popup"
                    setLayoutType={setLayoutType}
                    leadInLogin={leadInLogin}
                    leadInPopup={leadInPopup}
                    isPayWall={isPayWall}
                    regWallInfo={regWall}
                    layoutType={layoutType}
                    {...props}
                />
            )}
        </View>
    );
};
